import React, { Component } from 'react'

import Create from '../Create'

import { Row, Col}  from '../../../../SPRINTA/atoms/Grid'
import Button from '../../../../SPRINTA/atoms/Button'
import Loading from '../../../../SPRINTA/atoms/Loading'

import T from '../../../../SPRINTA/translate/T'
import FontIcon from '../../../Components/Atom/FontIcon'
import * as event from '../../../Utils/event'

import style from './style.css'

export default class Continue extends Component {

    state = {
        form: {
            searchEvent:'',
        },
        events: [],
        loading: true,
        continue: false
    }
    loadEvents() {
        this.setState({
            loading: true
        })

        event.find(`order=desc&situation[0]=0&orderBy=id`)
        .then(data => {
           let events = []
           if(data.result && data.result.list)
            events = data.result.list
            
            this.setState({
                events,
                loading: false
            })
        })
    }
    componentWillMount() {
       this.loadEvents()
    }

    handleDelete( id ) {
        let events = this.state.events
        let eventI = events.find(event => event.id === id)
        let inx = events.indexOf(eventI)
        events[inx].deleting = true
        this.setState({
            events
        })

        event.remove(id)
        .then(data => {
            events.splice(inx, 1)
            this.setState({
                events
            }, () => {
                if(this.state.events.length === 0)
                    this.loadEvents()
            })
        })
    }

    handleContinue( id ) {
        this.setState({
            continue: id
        })
    }

    render() {

        if(this.state.continue) {
            return (
                <Create scrollToStart={() => this.props.scrollToStart()} handleFinished={this.props.handleFinished} event={this.state.continue} />
            )
        }

        return (
            <div className={style.criarWrap}>
                <div className={style.criar}>
                    <h1>{T.text('continue_title')}</h1>

                    { this.state.loading ?
                        <div style={{
                                        marginTop: '30px',
                                        float: 'left',
                                        width: '100%',
                                        margin: '20px 0'
                                    }}>
                            <Loading />
                        </div>
                    :
                        <div className={style.continuewrap}>
                            {this.state.events.length === 0 && (
                                <p align='center'>{T.text('zero_events')}</p>
                            )}
                            {this.state.events.map(event =>

                                <div
                                    style={{
                                        opacity: event.deleting ? '0.3' : '1'
                                    }}
                                    key={event.id}
                                    className={style.continueitem}
                                    >
                                    <Row>
                                        <Col size="12 7">
                                            {event.title !== ''
                                                ? <p>{event.title}</p>
                                                : <p style={{ fontStyle: 'italic' }}>{T.text('event_without_title')}</p>
                                            }
                                        </Col>
                                        <Col size="12 5">
                                            <Row>
                                                <Col size="5 8" text="left right">
                                                    <Button
                                                        inline
                                                        theme='primary'
                                                        onClick={() => {
                                                            this.handleContinue(event.id)
                                                        }}
                                                        >
                                                            {T.txt('continue')}
                                                    </Button>
                                                </Col>
                                                <Col size="1 3" text="left center">
                                                    <span onClick={() => this.handleDelete(event.id)}>
                                                        <FontIcon name="trash" color="white" size={10} />
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/pages/CreateEvent/Continue/index.js